import { render, staticRenderFns } from "./InformationLetterList.vue?vue&type=template&id=36b68aa3&"
import script from "./InformationLetterList.vue?vue&type=script&lang=js&"
export * from "./InformationLetterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports